import '@fontsource/gochi-hand/400.css';
import '@fontsource/patrick-hand/400.css';
import '@fontsource/itim/400.css';
import './styles/main.css';
import './styles/paper.css';
import './styles/menu.css';
import './styles/notebook.css';
import './styles/battle.css';
import './styles/creator.css';
import './styles/skin.css';
import './styles/stage.css';
import './styles/skin-pieces.css';
import './styles/family.css';
import './styles/contest.css';
import './styles/daily.css';
import './styles/community.css';
import './styles/chat.css';
import './styles/account.css';
import './styles/classroom.css';
import './styles/fortune.css';
import { App } from './app/App';
import { installSvgFilters } from './ui/doodleSvg';
import { initSkin } from './ui/skin';

installSvgFilters();
const app = new App();
initSkin().then(() => app.start()).catch((err: unknown) => {
  console.error(err);
  const boot = document.getElementById('boot') ?? document.body;
  boot.innerHTML = `<div class="boot-error sticky-note pink"><h2>The notebook would not open :(</h2><p>${err instanceof Error ? err.message : String(err)}</p><p>Try a recent Chrome, Edge, Firefox or Safari.</p></div>`;
});

// Exposed for debugging and automated smoke tests.
(window as unknown as { paperLegends: App }).paperLegends = app;
